/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
v3RegistrationApp.controller("signOutCtrl",['$scope', 'DebugHelper', 'UserManager', 'V3SessionResource', '$window', 'AmplitudeService', function($scope, DebugHelper, UserManager, V3SessionResource, $window, AmplitudeService){
  DebugHelper.register("signOutCtrl", $scope);
  // wait until after user is loaded
  // V3 My profile sets cookies when logged in
  return UserManager.loadUser().then(function(currentUser) {
    AmplitudeService.setUserId(null);
    AmplitudeService.regenerateDeviceId();
    return V3SessionResource.destroy({}
    , success => $window.location.href = Packs.iKnowRoutes.v3_root_path()
    , function(error) {
      DebugHelper.logError(error);
      return $window.location.href = Packs.iKnowRoutes.v3_signin_path({error: "Error signing out"});
    });
  });
}
]);
